import AuthAPI from "./authInstance";

const analyzeText = async (data) => {
  const response = await AuthAPI.post(`/checker/analyze-text-beta`, data);
  return response.data;
};

export const sensitivityCheckerService = {
  analyzeText
};